import { useCallback } from "react";
import { useSearchStorage } from "src/storage/useSearchStorage";

export const useToggleTagSelection = () => {
  const { appTags, setAppTags } = useSearchStorage();

  return useCallback(
    (tagId: number) => {
      const tags = appTags ?? [];
      const tagAlreadyExists = tags.includes(tagId);
      const newTags = tagAlreadyExists
        ? tags.filter((t) => t !== tagId)
        : [...tags, tagId];

      setAppTags(newTags);
    },
    [appTags, setAppTags]
  );
};
